module.exports = __webpack_public_path__ + "img/la-inceput.43d599ed.jpg";